import React from 'react'

import AttachmentButtonDownload from "../blocks/buttons/download"
import Attachment from "../../../../model2/attachment/attachment"
import AttachmentButtonRemove from "../blocks/buttons/remove"

type Props = {
    attachment  : Attachment
    mode        : 'view-in-editor' | 'edit-in-editor' | 'notes-edit'

    onRemove    : callback
}

const debug = false
// const debug = "AttachmentViewNoPreviewInEditor"

export default class AttachmentViewNoPreviewInEditor extends React.Component<Props> {

    onRemoveClick = () => {
        if (this.props.onRemove) this.props.onRemove(this.props.attachment)
    }

    onDeleteClick = () => {
        // if (this.props.onRemove) this.props.onRemove(this.props.attachment)
        // console.log("wee need to delete it ?")
        // console.log(this.props.attachment.attachmentManager)

        // remove from message
        if (this.props.onRemove) this.props.onRemove(this.props.attachment)

        // then delete
        this.props.attachment.refAttachmentManager.current.onRemove(this.props.attachment)
    }

    render() {
        let mode = this.props.mode
        if (this.props.attachment.renderMode) mode = this.props.attachment.renderMode // redefine

        return (
            <div className="ui5-attachment-no-preview">
                <div className="preview">
                    <div className="ui5-ico-18 i5-file-code" />
                </div>
                <div className="details">
                    <div className="file-name ui5-txt-less-important-tiny">{this.props.attachment.name}</div>
                </div>

                {mode === 'notes-edit' &&
                    <div className="overlay-details">
                        <div className="file-size ui5-txt-not-important-tiny m-l-10 ">{this.props.attachment.fileSizeFormatted}</div>
                        <div className="attachment-preview-actions">
                            <div className="attachment-buttons-block">
                                <AttachmentButtonRemove onClick={this.onDeleteClick}/>
                                <div className="buttons-separator"/>
                                <AttachmentButtonDownload attachment={this.props.attachment}/>
                            </div>
                        </div>
                    </div>
                }

                {mode === 'view-in-editor' &&
                    <div className="overlay-details">
                        <div className="file-size ui5-txt-not-important-tiny m-l-10 ">{this.props.attachment.fileSizeFormatted}</div>
                        <div className="attachment-preview-actions">
                            <div className="attachment-buttons-block">
                                <AttachmentButtonDownload attachment={this.props.attachment}/>
                            </div>
                        </div>
                    </div>
                }

                {mode === 'edit-in-editor' &&
                    <div className="overlay-actions">
                        <div className="attachment-preview-actions">
                            <div className="attachment-buttons-block">
                                <AttachmentButtonRemove onClick={this.onRemoveClick}/>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}